import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import notify from 'devextreme/ui/notify';
import { filter } from 'rxjs/operators';
import { AppConstants } from '../../../../../core/constants/app-constants';
import { List } from '../../../../../core/infrastructure/linq';
import { AbstractDashboardApiService } from '../../../../../core/services/abstract/abstract-dashboard-api-service';
import { DashboardModel } from '../../../../../store/dashboard/model';
import { ServiceCatalogFacade } from '../../../../../store/self-diagnostic/service-catalog/facade';
import { ServiceModel } from '../../../../../store/self-diagnostic/service-catalog/model';
import { TopServiceFacade } from '../../../../../store/self-diagnostic/top-service/facade';
import { TopServiceModel } from '../../../../../store/self-diagnostic/top-service/model';
import { UserFacade } from '../../../../../store/user/facade';
import { UserModel } from '../../../../../store/user/model';
import { DialogEditImageComponent } from '../../service-catalog/dialogs/dialog-edit-image/dialog-edit-image.component';

@Component({
  selector: 'admin-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  host: {
    class: 'd-block',
  },
  standalone: false,
})
export class DashboardComponent implements OnInit {
  translate = inject(TranslateService);
  sanitizer = inject(DomSanitizer);
  private dashboardApiService = inject(AbstractDashboardApiService);
  private serviceCatalogFacade = inject(ServiceCatalogFacade);
  private topServiceFacade = inject(TopServiceFacade);
  private userFacade = inject(UserFacade);

  @ViewChild(DialogEditImageComponent) dialogEditImage: DialogEditImageComponent;

  public user: UserModel;
  public isLanguageUa: boolean;

  public entity: DashboardModel = new DashboardModel();
  public topServices: TopServiceModel[] = [];

  pages = [
    { id: 1, caption: 'рус' },
    { id: 2, caption: 'укр' },
  ];

  public async ngOnInit() {
    await this.load();

    this.userFacade.selected().subscribe(user => {
      this.user = { ...user };

      this.isLanguageUa = !this.user?.language || this.user?.language == AppConstants.LANGUAGE_UK;
    });

    this.topServiceFacade.entities$.pipe(filter(ts => Array.isArray(ts) && !!ts.length)).subscribe(ts$ => {
      this.serviceCatalogFacade.entities$.pipe(filter(s => Array.isArray(s) && !!s.length)).subscribe(s$ => {
        let services = new List<ServiceModel>(s$);
        let topServices = new List<TopServiceModel>(ts$).Select(ts => {
          return { ...ts };
        });

        topServices.ForEach(ts => {
          ts.service = { ...services.Single(s => s.id == ts.serviceId) };
        });

        this.topServices = topServices.ToArray();
      });
    });
  }

  private async load() {
    let response = await this.dashboardApiService.load().toPromise();

    if (response.isSucceeded) {
      this.entity = response.result ?? new DashboardModel();
    } else {
      notify('load error', 'error', 3000);
    }
  }

  public async save() {
    let response = await this.dashboardApiService.save(this.entity).toPromise();

    if (response.isSucceeded) {
      notify('save success', 'success', 3000);
      await this.load();
    } else {
      notify('save error', 'error', 3000);
    }
  }

  public uploadImage() {
    this.dialogEditImage.show().subscribe(async result => {
      if (result) {
        let response = await this.dashboardApiService.uploadBackgroundImage(result).toPromise();

        if (response.isSucceeded) {
          notify('upload success', 'success', 3000);
          await this.load();
        } else {
          notify('upload image error', 'error', 3000);
        }
      }
    });
  }

  public async deleteImage() {
    let response = await this.dashboardApiService.deleteBackgroundImage().toPromise();

    if (response.isSucceeded) {
      notify('delete success', 'success', 3000);
      await this.load();
    } else {
      notify('delete image error', 'error', 3000);
    }
  }

  public upPriorityTopService($event) {
    let entity = <TopServiceModel>$event.data;

    this.topServiceFacade.upPriority(entity);
  }

  public downPriorityTopService($event) {
    let entity = <TopServiceModel>$event.data;

    this.topServiceFacade.downPriority(entity);
  }

  public saveTopService($entity: TopServiceModel) {
    this.topServiceFacade.save($entity);
  }

  public deleteTopService($event) {
    this.topServiceFacade.delete($event.data.id);
  }

  public sync() {
    this.topServiceFacade.sync();
  }
}
